import React, { FC } from 'react';
import styled from '@emotion/styled';
import PersonIcon from '~Assets/icons/person.svg';
import Icon from '~ComponentsImproved/Icon';

const Wrapper = styled.div`
  position: absolute;
  top: 4px;
  left: 4px;
  display: flex;
  justify-content: center;
`;

/** Component floating in absolute on chequeitem to indicate that a member has been linked to the cheque */
const Member: FC = () => {
  return (
    <Wrapper>
      <Icon color="var(--colorBlueGray800)" height="12px" width="12px" src={PersonIcon} />
    </Wrapper>
  );
};

export default Member;
